(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mniowig-welcome-offer"]) return;
  try {
    
  if (!customElements.get('mnw-welcome-offer')) {
    customElements.define('mnw-welcome-offer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.ready) return;
        this.ready = true;
        this.key = 'mnw-offer-' + this.dataset.code + '-v1';
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tab = this.querySelector('.mnw-offer-tab');
        this.tab.addEventListener('click', () => this.openOffer(), options);
        this.querySelector('.mnw-offer-close').addEventListener('click', () => this.closeOffer(), options);
        this.querySelector('.mnw-offer-dismiss').addEventListener('click', () => this.closeOffer(), options);
        this.dialog.addEventListener('cancel', () => this.remember(), options);
        this.dialog.addEventListener('close', () => { if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true }); }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeOffer();
        }, options);
        const apply = this.querySelector('.mnw-offer-apply');
        const current = new URL(window.location.href);
        if (current.searchParams.get('mnw_offer') === 'claimed') this.remember();
        current.searchParams.set('mnw_offer', 'claimed');
        current.hash = '';
        const discount = new URL(apply.href);
        discount.searchParams.set('redirect', current.pathname + current.search);
        apply.href = discount.href;
        apply.addEventListener('click', () => { this.remember(); this.dialog.close(); }, options);
        let suppressed = false;
        try { suppressed = Date.now() < Number(localStorage.getItem(this.key)) || sessionStorage.getItem(this.key) === 'shown'; } catch (_) {}
        if (!suppressed && this.dataset.editor !== 'true') this.timer = setTimeout(() => this.tryOpen(), Math.max(0, Number(this.dataset.delay)) * 1000);
      }
      remember() {
        try { localStorage.setItem(this.key, String(Date.now() + Number(this.dataset.days) * 86400000)); sessionStorage.setItem(this.key, 'shown'); } catch (_) {}
      }
      tryOpen() {
        if (!this.isConnected) return;
        const consent = document.getElementById('shopify-pc__banner');
        const busy = document.hidden || (consent && consent.getClientRects().length > 0) || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select');
        if (busy) { this.timer = setTimeout(() => this.tryOpen(), 3000); return; }
        this.openOffer();
      }
      openOffer() {
        clearTimeout(this.timer);
        if (!this.dialog.open && typeof this.dialog.showModal === 'function') {
          this.previousFocus = document.activeElement;
          this.dialog.showModal();
          this.remember();
        }
      }
      closeOffer() { this.remember(); this.dialog.close(); }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.ready = false; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mniowig-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mniowig-welcome')) {
    customElements.define('mniowig-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.teaser = this.querySelector('.mnw-welcome__teaser');
        this.editor = this.dataset.editor === 'true';
        this.form = this.querySelector('form');
        this.submitStatus = this.querySelector('[data-submit-status]');
        this.pendingKey = 'mnw-welcome-pending';
        this.storageKey = 'mnw-welcome-v1';
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.querySelector('[data-open]').addEventListener('click', () => this.open(), options);
        this.querySelector('[data-dismiss]').addEventListener('click', () => this.dismiss(), options);
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('close', () => {
          if (this.dialog.open) return;
          this.removeAttribute('data-verifying');
          this.clearSubmitFeedback();
          this.remember(this.submitted ? 'submitted' : 'dismissed');
          this.teaser.hidden = Boolean(this.submitted);
        }, options);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && String(event.detail.sectionId) === this.dataset.sectionId) this.open();
        }, options);
        if (this.form && this.submitStatus) {
          this.form.addEventListener('invalid', event => {
            this.clearSubmitFeedback();
            this.setSubmitStatus(event.target.validationMessage);
          }, { ...options, capture: true });
          this.form.addEventListener('submit', () => {
            this.setSubmitStatus(this.submitStatus.dataset.submitting);
            this.form.setAttribute('aria-busy', 'true');
            try {
              sessionStorage.removeItem('mnw-form-pending-v1');
              sessionStorage.setItem(this.pendingKey, this.dataset.formId);
            } catch {}
            this.allowVerification();
            window.clearTimeout(this.submitTimer);
            this.submitTimer = window.setTimeout(() => {
              this.form.removeAttribute('aria-busy');
              this.setSubmitStatus(this.submitStatus.dataset.waiting);
            }, 15000);
          }, { ...options, capture: true });
          window.addEventListener('pageshow', event => {
            if (event.persisted) this.clearSubmitFeedback();
          }, options);
        }
        let pendingReturn = false;
        try { pendingReturn = sessionStorage.getItem(this.pendingKey) === this.dataset.formId; } catch {}
        const ownReturn = window.location.hash === '#' + this.dataset.formId || pendingReturn;
        this.submitted = Boolean(ownReturn && this.querySelector('[data-success]'));
        if (this.submitted || (ownReturn && this.querySelector('[data-error]'))) {
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
          if (this.submitted) this.remember('submitted');
          this.open();
          return;
        }
        if (pendingReturn) {
          try { sessionStorage.removeItem(this.pendingKey); } catch {}
          this.open();
          this.setSubmitStatus(this.submitStatus?.dataset.waiting);
          return;
        }
        const state = this.readState();
        if (state.status === 'submitted') return;
        if (state.until > Date.now()) {
          this.teaser.hidden = false;
          return;
        }
        this.timer = window.setTimeout(() => {
          if (!this.isConnected) return;
          this.teaser.hidden = false;
          const active = document.activeElement;
          const visitorBusy = active && active.matches('input, textarea, select, [contenteditable="true"]');
          const anotherDialog = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]');
          if (!state.storageUnavailable && !this.editor && document.visibilityState === 'visible' && window.matchMedia('(min-width: 750px)').matches && !visitorBusy && !anotherDialog) this.open();
        }, Math.max(1, Number(this.dataset.delay) || 8) * 1000);
      }
      setSubmitStatus(message) {
        if (!this.submitStatus) return;
        this.submitStatus.textContent = message || '';
        this.submitStatus.hidden = !message;
      }
      clearSubmitFeedback() {
        window.clearTimeout(this.submitTimer);
        this.form?.removeAttribute('aria-busy');
        this.setSubmitStatus('');
      }
      allowVerification() {
        if (!this.dialog.open || !this.dialog.matches(':modal')) return;
        this.setAttribute('data-verifying', '');
        this.dialog.close();
        this.dialog.show();
      }
      readState() {
        try { return JSON.parse(localStorage.getItem(this.storageKey) || '{}') || {}; }
        catch { return { storageUnavailable: true }; }
      }
      remember(status) {
        if (this.editor) return;
        try {
          localStorage.setItem(this.storageKey, JSON.stringify({ status, until: Date.now() + Math.max(1, Number(this.dataset.cooldown) || 7) * 86400000 }));
        } catch {}
      }
      open() {
        if (!this.dialog.open) {
          this.dialog.showModal();
          this.teaser.hidden = true;
          const message = this.querySelector('[data-success], [data-error]');
          if (message) message.focus();
        }
      }
      dismiss() {
        this.remember('dismissed');
        this.teaser.hidden = true;
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.submitTimer);
        this.controller?.abort();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
